import React from 'react';
import {
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Box,
} from '@mui/material';
import { HeadCell } from '../../models/Table';
import { FlexBox, FlexBoxBetween } from '../../components/tableItems';
import { DefaultCheckbox } from '../../components/inputs';

interface ProspectingHeadTableProps {
  onRequestSort: (property: string) => void;
  order: 'asc' | 'desc';
  orderBy: string;
  headCells: HeadCell[];
  checkbox: { checked: boolean; indeterminate: boolean; click: () => void };
  selected: number[];
  openModal: () => void;
  handleSubmit: () => void;
  length: number;
}

const ProspectingHeadTable = ({
  onRequestSort,
  order,
  orderBy,
  headCells,
  checkbox,
  selected,
  openModal,
  handleSubmit,
  length,
}: ProspectingHeadTableProps) => {
  return (
    <TableHead sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            sx={{
              minWidth: 140,
              color: '#787878',
              fontSize: 13,
            }}
            align={headCell.main ? 'left' : 'center'}
            className={headCell.main ? 'first_column' : 'present-column'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.main ? (
              <FlexBoxBetween>
                <FlexBox>
                  <DefaultCheckbox
                    sx={{ marginLeft: 1 }}
                    checked={checkbox.checked}
                    indeterminate={checkbox.indeterminate}
                    onClick={() => checkbox.click()}
                  />
                  <TableSortLabel
                    sx={{ paddingLeft: 1 }}
                    active={orderBy === headCell.id}
                    disabled={headCell.disableSort}
                    direction={order}
                    onClick={() => {
                      onRequestSort(headCell.id);
                    }}
                  >
                    {headCell.label}
                  </TableSortLabel>
                </FlexBox>
                <Box paddingRight={1}>
                  <button
                    type="button"
                    className="mail-merge"
                    onKeyDown={e => e.preventDefault()}
                    disabled={selected.length === 0}
                    onClick={openModal}
                  >
                    Bulk Assign
                  </button>
                  <button
                    type="button"
                    className="mail-merge"
                    onKeyDown={e => e.preventDefault()}
                    disabled={length === 0}
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </Box>
              </FlexBoxBetween>
            ) : (
              <TableSortLabel
                active={orderBy === headCell.id}
                disabled={headCell.disableSort}
                direction={order}
                onClick={() => {
                  onRequestSort(headCell.id);
                }}
              >
                {headCell.label}
              </TableSortLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default ProspectingHeadTable;
